import { useQuery } from "@tanstack/vue-query";
import { Ref } from "vue";

import { ConsumptionQueryKeys } from "@/data/api/kili/consumption/consumption-query-keys";
import { TSiteIdsQuery } from "@/data/api/kili/consumption/types/multisite-consumption.type";
import KiliApi from "@/data/api/kili/kili-api";

export function useGetHeatmapQuery(siteIds: Ref<TSiteIdsQuery>) {
  return useQuery({
    queryKey: ConsumptionQueryKeys.heatmapConsumption(siteIds),
    queryFn: () => KiliApi.getHeatmapPoints({ queries: { siteIds: siteIds.value ?? undefined } }),
  });
}
